import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdateSessionMutation } from '../../../redux/api/sessions';
import Button from '../../Utils/Button';
import FormInput from '../../Utils/Form/FormInput';
import IfRender from '../../Utils/IfRender';
import './style.scss';
import { filter } from 'lodash';
import { useSelector } from 'react-redux';

export default function SessionLabel({
  label = '',
  sessionId,
  transactionId,
  chargerId,
  isActive,
  setIsActive
}) {
  const user = useSelector((state) => state.auth.user);
  const [sessionLabel, setSessionLabel] = useState(label);
  const [updateSession, { isLoading, isSuccess, isError, error, data }] =
    useUpdateSessionMutation();
  const saveSessionLabel = async () => {
    await updateSession({
      where: { id: String(sessionId) },  // Convert to string
      data: { label: sessionLabel },
      userId: user.id
    });
    setIsActive(false);
  };
  const { t } = useTranslation();

  useEffect(() => {
    if (isError) {
      setSessionLabel(label);
      console.error('error', error);
    }
  }, [isError]);

  return (
    <form className='session-label__wrap'>
      <IfRender
        condition={isActive}
        otherwise={
          <>
            <Button
              className='button__icon color--alfa-foreground'
              iconName='label'
              onClick={() => {
                setIsActive(true);
              }}
            />
            <p>{sessionLabel}</p>
          </>
        }>
        <FormInput
          id='session-label'
          placeholder={t('add_session_label')}
          value={sessionLabel}
          maxLength={20}
          onChange={(e) => {
            setSessionLabel(e.target.value);
          }}
        />
        <Button
          className='button__icon color--alfa-color'
          label={t('save')}
          onClick={saveSessionLabel}
        />
        <Button
          className='button__icon color--bravo-color'
          iconName='trash'
          onClick={() => {
            setSessionLabel('');
            setIsActive(false);
            updateSession({
              where: { id: String(sessionId) },  // Convert to string
              userId: user.id,
              data: { 
                label: null,
                transactionId,
                chargerId
              }
            });
          }}
        />
      </IfRender>
    </form>
  );
}

SessionLabel.propTypes = {
  label: PropTypes.string,
  sessionId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  transactionId: PropTypes.number,
  chargerId: PropTypes.string,
  isActive: PropTypes.bool,
  setIsActive: PropTypes.func
};
